import React from 'react'
import { Element } from 'react-bulma-components'
import { UserRole, UserAssociation } from '../../api/users'
import locales from '../../../../locales/users'

interface RoleStatusDescriptionProps {
  role: UserRole | UserAssociation | { status: UserRole['status'] }
}

const RoleStatusDescription: React.FC<RoleStatusDescriptionProps> = ({ role }) => {
  const getDescription = () => {
    switch (role.status) {
      case 'accepted':
        return 'Vous collaborez avec ce travailleur. Des missions peuvent lui être affectées.'
      case 'pending':
        return "Vous avez invité ce travailleur à collaborer, mais il n'a pas encore répondu à votre invitation. Cependant, des missions peuvent lui être affectées."
      case 'rejected':
        return 'Vous avez invité ce travailleur à collaborer, mais il a refusé votre invitation. Il ne peut plus être affecté à des missions.'
      case 'discontinued':
        return 'Vous avez interrompu la collaboration avec ce travailleur. Il ne peut plus être affecté à des missions.'
      default:
        return ''
    }
  }

  return (
    <Element renderAs="p" mb={3}>
      {getDescription()}
    </Element>
  )
}

export default RoleStatusDescription
